<template>
    <v-dialog
        :value="value"
        :v-bind="$attrs"
        v-on="$listeners"
        min-width="300"
        max-width="500"
        @click:outside="handleCloseDialog"
    >
        <v-alert v-if="type == 'success'"
            color="green lighten-1"
            colored-border
            border=left
            icon="fas fa-check"
            prominent
            class="pl-6 py-5 mb-0"
        >
            <h2 class="ml-2 alert-title green--text text--lighten-2">{{ title }}</h2>
            <p class="mt-4 ml-2" v-html="message"></p>
        </v-alert>
        <v-alert v-else-if="type == 'error'"
            color="red"
            colored-border
            border=left
            icon="fas fa-exclamation"
            prominent
            class="pl-6 py-5 mb-0"
        >
            <h2 class="ml-2 alert-title red--text text--lighten-2">{{ title }}</h2>
            <p class="mt-4 ml-2"><span v-html="message"></span></p>
        </v-alert>
    </v-dialog>
</template>

<script>
export default {
    props: {
        type: String,
        value: Boolean,
        title: String,
        message: String,
    },
    methods: {
        handleCloseDialog (event) {
            this.$emit('handleCloseDialog', this.type)
        }
    }
}
</script>